__turbopack_context__.v({
  "h1": "PlasmicRemarketing-module__Pv1ubG__h1",
  "primaryButton": "PlasmicRemarketing-module__Pv1ubG__primaryButton",
  "root": "PlasmicRemarketing-module__Pv1ubG__root",
  "section": "PlasmicRemarketing-module__Pv1ubG__section",
  "svg__ginVl": "PlasmicRemarketing-module__Pv1ubG__svg__ginVl",
  "svg__wgKq": "PlasmicRemarketing-module__Pv1ubG__svg__wgKq",
  "text___5B5Qr": "PlasmicRemarketing-module__Pv1ubG__text___5B5Qr",
  "text__g6FcP": "PlasmicRemarketing-module__Pv1ubG__text__g6FcP",
  "text__jR2Co": "PlasmicRemarketing-module__Pv1ubG__text__jR2Co",
  "text__l4RtV": "PlasmicRemarketing-module__Pv1ubG__text__l4RtV",
  "text__qhBQa": "PlasmicRemarketing-module__Pv1ubG__text__qhBQa",
  "text__uPUam": "PlasmicRemarketing-module__Pv1ubG__text__uPUam",
  "ul__d5RyZ": "PlasmicRemarketing-module__Pv1ubG__ul__d5RyZ",
  "ul__mCOjz": "PlasmicRemarketing-module__Pv1ubG__ul__mCOjz",
});
